<script>
  import { fade } from 'svelte/transition'
  import { clickOutside } from "../modules/helpers";
  import Button from "./Button.svelte";
  
  export let trigger_text = "Dropdown"
  export let notification = false
  export let button_on_fill = false

  let is_visible = false
  let hovering = false

</script>

<div 
class="dropdown" 
class:notification
use:clickOutside 
on:click_outside={() => is_visible = false}>
  
  <Button 
  kind={is_visible ? 'default' : 'outline'}
  on_fill={button_on_fill}
  on:click={()=> is_visible = !is_visible}
  on:mouseenter={() => hovering = true}
  on:mouseleave={() => hovering = false}>
    {trigger_text} <span class="caret" class:hovering class:active={is_visible}></span>
  </Button>

  {#if is_visible}
    <div class="content" transition:fade="{{duration: 100}}">
      <slot/>
    </div>
  {/if}
</div>

<style>
  .dropdown {
    z-index: 2;
    position: relative;
    display: inline-block;
  }
  .content {
    position: absolute;
    top: 5rem;
    right: 0;
    padding: 1.5rem;
    min-width: 20rem;
    color: var(--c-text);
    background-color: var(--c-content-bg);
    border-radius: 2rem;
    box-shadow: var(--box-shadow);
  }
  .caret:before {
    content: "";
    display: inline-block;
    width: 0.8rem;
    height: 0.8rem;
    margin-left:0.4rem;
    border-right: 2px solid var(--c-text-on-fill);
    border-bottom: 2px solid var(--c-text-on-fill);
    transform: rotate(45deg) translateX(-3px);
    transform-origin: center;
    transition: border-color var(--transition-props);
  }
  .caret.hovering:before,
  .caret.active::before {
    border-right-color: var(--c-text-on-fill);
    border-bottom-color: var(--c-text-on-fill);
  }
  .caret.active::before {
    transform: rotate(225deg) translateX(1px) translateY(-2px);
  }
  .notification:after {
    content: "1";
    position: absolute;
    right: -0.5rem;
    top: -0.5rem;
    width: 2rem;
    height: 2rem;
    font-size: 1.2rem;
    line-height: 1rem;
    font-weight: bold;
    text-align: center;
    font-family: var(--PensumSans-Bold);
    color: var(--c-text-on-fill);
    background-color: var(--c-accent-orange);
    border-radius: 1.5rem;
    border: 3px solid var(--c-accent-fill);
  }
</style>